const hoc = (props) => props.children;

export default hoc;


// WEBPACK FOOTER //
// ./src/hoc/hoc.js